'use client';

import Script from 'next/script';

export default function AnalyticsScripts() {
  return (
    <>
      {/* Usercentrics Cookie Banner Scripts */}
      <Script
        id="usercentrics-autoblocker"
        src="https://web.cmp.usercentrics.eu/modules/autoblocker.js"
        strategy="beforeInteractive"
        onError={(e) => console.error('Usercentrics autoblocker script failed to load:', e)}
      />
      <Script
        id="usercentrics-cmp"
        src="https://web.cmp.usercentrics.eu/ui/loader.js"
        data-settings-id="l2zvA8aEpqZlH0"
        strategy="beforeInteractive"
        onLoad={() => console.log('Usercentrics CMP script loaded successfully')}
        onError={(e) => console.error('Usercentrics CMP script failed to load:', e)}
      />
      {/* Microsoft Clarity Script */}
      <Script
        id="microsoft-clarity-init"
        strategy="beforeInteractive"
        onLoad={() => console.log('Microsoft Clarity script loaded successfully')}
        dangerouslySetInnerHTML={{
          __html: `
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "qqopc9hgm8");
    `,
        }}
      />
    </>
  );
}
